export const WSS_URL = import.meta.env.VITE_WSS_URL;
export const API_URL = import.meta.env.VITE_API_URL;